function cryptoIcon() {
    return {
        componentName: 'cryptoIcon',
        baseStyle: {
            display: 'flex'
        },
        variants: {},
        defaultProps: {}
    };
}

export { cryptoIcon as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3J5cHRvSWNvbi5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3RoZW1lL2NvbXBvbmVudHMvY3J5cHRvSWNvbi50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDb21wb25lbnRTdHlsZSB9IGZyb20gJy4uL3R5cGVzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3J5cHRvSWNvbigpOiBDb21wb25lbnRTdHlsZSB7XG4gIHJldHVybiB7XG4gICAgY29tcG9uZW50TmFtZTogJ2NyeXB0b0ljb24nLFxuICAgIGJhc2VTdHlsZToge1xuICAgICAgZGlzcGxheTogJ2ZsZXgnXG4gICAgfSxcbiAgICB2YXJpYW50czoge30sXG4gICAgZGVmYXVsdFByb3BzOiB7fVxuICB9O1xufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVjLFNBQVUsVUFBVSxHQUFBO0lBQ2hDLE9BQU87QUFDTCxRQUFBLGFBQWEsRUFBRSxZQUFZO0FBQzNCLFFBQUEsU0FBUyxFQUFFO0FBQ1QsWUFBQSxPQUFPLEVBQUUsTUFBTTtBQUNoQixTQUFBO0FBQ0QsUUFBQSxRQUFRLEVBQUUsRUFBRTtBQUNaLFFBQUEsWUFBWSxFQUFFLEVBQUU7S0FDakIsQ0FBQztBQUNKOzs7OyJ9
